import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/site";
import { ORDER_URL } from "../data/menu";

export const SignatureHighlight = () => {
  return (
    <section
      id="signature"
      data-testid="signature-section"
      className="relative bg-brand-red text-brand-cream overflow-hidden"
    >
      <div className="absolute -top-32 -left-32 w-[28rem] h-[28rem] rounded-full bg-brand-mustard/20 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-[34rem] h-[34rem] rounded-full bg-brand-deepred/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 1.08 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7 relative"
        >
          <div className="relative aspect-[5/4] rounded-3xl overflow-hidden shadow-[0_40px_100px_-20px_rgba(0,0,0,0.5)]">
            <img
              src={IMAGES.signatureBiryani}
              alt="Red Chilly's Special Chicken Biryani"
              className="w-full h-full object-cover"
            />
            <div className="absolute top-6 left-6 px-4 py-2 rounded-full bg-brand-cream text-brand-red font-heading uppercase text-[10px] tracking-[0.25em] font-bold">
              House Signature
            </div>
          </div>

          {/* huge background number */}
          <div className="hidden md:block absolute -top-10 -left-10 font-display text-[12rem] leading-none text-brand-cream/10 select-none pointer-events-none">
            01
          </div>
        </motion.div>

        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-mustard">
              · The Crown Jewel
            </span>
            <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-brand-cream">
              Red Chilly's<br />
              <span className="text-brand-mustard italic">Special Biryani.</span>
            </h2>
            <p className="mt-7 text-lg text-brand-cream/80 leading-relaxed text-balance">
              Long-grain basmati layered with hand-marinated chicken, slow dum-cooked
              over coal in a sealed clay pot for 90 minutes. Saffron, fresh mint,
              caramelised onions, and the closely-guarded house masala — exactly the
              way it's been made for three generations.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              {[
                { n: "90", l: "Min Dum" },
                { n: "22", l: "Spices" },
                { n: "3", l: "Generations" },
              ].map((s) => (
                <div key={s.l} className="border-l-2 border-brand-mustard pl-4">
                  <div className="font-display text-3xl text-brand-mustard">{s.n}</div>
                  <div className="font-heading uppercase text-[10px] tracking-[0.2em] font-bold mt-1 text-brand-cream/70">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>

            <a
              href={ORDER_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="signature-order-cta"
              className="mt-10 group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-cream text-brand-red font-heading uppercase text-xs tracking-[0.2em] font-bold hover:bg-brand-mustard hover:text-brand-charcoal transition-all hover:-translate-y-1 shadow-2xl"
            >
              Order The Signature
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
